import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '../BlogStyles';
import image from './image.jpg';

const ForSchools = ({ classes }) => (
  <div className={classes.container}>
    <img src={image} className={classes.image} alt="" />
    <h4>The importance of literacy extends beyond the classroom.</h4>
    <b>Ashley Jones | 29 September 2022 | 3 mins</b>
    <p>
      Before online learning took root, tutoring services existed exclusively
      in-person, typically after-school. The process was almost always the same.
    </p>
    <p>
      A student&quot;s parent(s) would have to take the initiative to hire an
      after-school tutor. They would begin to search for a private tutor who
      matched their desired availability and had expertise in the necessary
      subject matter. The student&quot;s parents would then take their child to
      the tutor&quot;s home or make space for the tutor in their household. And
      the parents would have to pay the tutor out of pocket.
    </p>
    <p>
      Earlier this year<a href="https://www.usnews.com/education/k12/articles/how-to-find-a-tutor-for-your-child">
        US News
      </a>
      reported the average in-person tutor charges about 25 dollars an hour for
      basic subjects with the rate even reaching $49 per hour for specialized
      support. The cost is high, but the investment pays dividends. Evidence
      collected by the
      <a href="https://www.govinfo.gov/content/pkg/ERIC-ED464343/pdf/ERIC-ED464343.pdf">
        US Department of Education
      </a>reports that frequent high dosage tutoring can lead to academic
      success<strong>. </strong>Strong grades and high board scores can create a
      pathway for college and, in turn, a higher paying career. But, not all
      families have the means to pay for private academic support. In an economy
      heavily impacted by a global pandemic, many parents are just trying to
      make ends meet.
    </p>
    <p>
      <strong>
        When online tutoring is integrated into the classroom environment, every
        student gets the opportunity for specialized instruction.
      </strong>
      Tutoring extends beyond the small subset of students whose parents have
      the resources to hire a private tutor. The barriers of time, space, and
      money are lifted off of struggling families when online tutoring takes
      place in the classroom.
    </p>
    <p>
      At Tutorfly, we&rsquo;ve seen students make dramatic progress after
      attending customized online tutoring sessions in subjects like English
      Language Arts (ELA) and math. By integrating our instruction into the
      school day, we connect and enrich student learning in a regular cadence.
      And our program does not compete with after-school activities, so students
      never feel like they are missing out on extra-curricular fun.
    </p>
    <p>
      When school districts and programs like Tutorfly work together to provide
      in-classroom tutoring, it creates an equitable educational experience for
      more students. It&rsquo;s an important step toward building a more
      equitable future for all.
    </p>
  </div>
);

ForSchools.propTypes = {
  classes: PropTypes.object.isRequired, // eslint-disable-line
};

export default withStyles(ForSchools);
